import React, { useState, useEffect } from "react";
import LazyLoad from "react-lazyload";
import { webPath } from "../apiConfig";

const AdCarousel = ({ ads = [], className,timer }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [fade, setFade] = useState(true);

  console.log('ads :',ads);
  const currentAd = ads[currentIndex];
 
//   useEffect(() => {
//     if (ads.length === 0) return;
// console.log("ads Data :",ads)
//     const interval = setInterval(() => {
//       setFade(false);
   
//         setCurrentIndex((prevIndex) => (prevIndex + 1) % ads.length);
//         setFade(true);
//       // short delay to reset animation
//     }, currentAd.duration_time*1000+1000);

//     // return () => clearInterval(interval);
//   }, [currentIndex]);

useEffect(() => {
    const timeout = setTimeout(() => {
      setFade(false);

      setTimeout(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % ads.length);
        setFade(true);
      }, 200); // allow fade-out before switching
    }, (currentAd?.duration_time || 5) * 1000); // default to 5s

    return () => clearTimeout(timeout);
  }, [currentIndex, ads]);


    useEffect(() => {
    const nextIndex = (currentIndex + 1) % ads.length;
    const nextImg = new Image();
    nextImg.src = `${webPath}${ads[nextIndex]?.banner_img}?width=400`;
  }, [currentIndex, ads]);
  return (
    <div className="marTop sticky-top" style={{ height: "auto" }}>
      {/* Inline animation styles */}
      <style>
        {`
          .ad-image {
            opacity: 0;
            transition: opacity 0.8s ease-in-out;
          }
          .ad-image.fade-in {
            opacity: 1;
          }
        `}
      </style>

      <LazyLoad className={className}>
        {currentAd && (
          <a
            href={currentAd?.dest_url}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={`${webPath}${currentAd?.banner_img}?width=400`}
              alt={currentAd?.banner_name}
              className={`ad-image ${fade ? "fade-in" : ""}`}
              style={{ width: "100%", height: "auto" }}
            />
          </a>
        )}
      </LazyLoad>
    </div>
  );
};

export default AdCarousel;
